
import { Options, setup, Vue } from "vue-class-component";
import { computed, defineAsyncComponent } from "vue";
import { useStore } from "vuex";
import { key } from "@/store";
import { useMeta } from "vue-meta";

@Options( {
  components : {
    Header : defineAsyncComponent( () => import("../components/Header.vue") ),
    Footer : defineAsyncComponent( () => import("../components/Footer.vue") )
  }
} )
export default class extends Vue
{
  store = useStore( key );

  partners = [];

  meta = setup( () => useMeta( computed( () => {
    return {
      title : [{
        content : "Location-gardemeuble.fr - Partenaires",
        vmid    : "title",
        name    : "title"
      }],
      description : {
        content : "Décrouvrez les partenaires de Location-gardemeuble.fr pour la location d'espace de stockage et le déménagement de vos biens.",
        vmid    : "description",
        name    : "description"
      }
    };
  } ) ) );

  linksNofollow( text:string )
  {
    return text.replaceAll( /<a /g, '<a rel="nofollow noopener"' );
  }

  mounted()
  {
    let request = fetch( this.store.state.api + "partners", {
      method  : "GET",
      cache   : "no-cache",
      headers : {
        "Content-Type" : "application/json",
        "Accept"       : "application/json"
      }
    } );

    request.then( ( res ) => { return res.json(); } ).then( ( json ) => { this.partners = json.data; } );
    request.catch( ( error ) => console.log( error ) );

    setTimeout( () => {
      this.store.state.loading = false;

      // Remove div#preload from DOM
      let preload = document.getElementById( "preload" );
      if( preload )
      {
        window.scrollTo( { top : 0 } );
        preload.remove();
      }
    }, this.store.state.delay );  }
}
